// ============================================================
//  Plan-Warenkorb — eigener Store, unabhängig vom AppStore, bleibt über Tab-Wechsel und
//  Reload erhalten (localStorage). Der Plan ist die einzige Quelle für „was tun wir".
//  Jede Position: eine Maßnahme + welche Personen dazugehören (Trace-Umfang) + Ticket-Häkchen.
// ============================================================
import { useSyncExternalStore } from "react";

/** Welche Träger der Maßnahme in den Plan kommen. */
export type TraceScope = "nie" | "nie+genutzt" | "alle";
export const TRACE_SCOPE_LABEL: Record<TraceScope, string> = {
  nie: "nur nie genutzt",
  "nie+genutzt": "nie genutzt und genutzt",
  alle: "alle, auch ohne Trace",
};

export interface PlanItem {
  leverId: string;
  scope: TraceScope;
  addedAt: number;
  /** Ticket im Hintergrund erstellt (Häkchen, keine Anbindung). */
  ticket: boolean;
}

const KEY = "rise-cockpit.plan.v1";
let items: PlanItem[] = load();
const listeners = new Set<() => void>();

function load(): PlanItem[] {
  try { const raw = localStorage.getItem(KEY); if (!raw) return []; const j = JSON.parse(raw); return Array.isArray(j) ? j.filter((x) => x && typeof x.leverId === "string") : []; } catch { return []; }
}
function persist() { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* privat/blockiert: nur im Speicher */ } }
function set(next: PlanItem[]) { items = next; persist(); for (const l of listeners) l(); }
function subscribe(l: () => void) { listeners.add(l); return () => { listeners.delete(l); }; }
const getSnapshot = () => items;

export const planStore = {
  get: getSnapshot,
  has: (leverId: string) => items.some((i) => i.leverId === leverId),
  add(leverId: string, scope: TraceScope = "nie") { if (planStore.has(leverId)) return; set([...items, { leverId, scope, addedAt: Date.now(), ticket: false }]); },
  update(leverId: string, patch: Partial<Omit<PlanItem, "leverId">>) { set(items.map((i) => (i.leverId === leverId ? { ...i, ...patch } : i))); },
  remove(leverId: string) { set(items.filter((i) => i.leverId !== leverId)); },
  clear() { set([]); },
};

/** Reaktiver Zugriff auf die Plan-Positionen. */
export function usePlanItems(): PlanItem[] {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
